import ServiceBase from '@/Services/ServiceBase';

export default class CampaignService extends ServiceBase {
    getAssetGroups(campaignID, includeSuggestions = false) {
        return this.request('get', `/campaign/${campaignID}/assetGroups`, { includeSuggestions });
    }

    createAssetGroup(campaignID, assetGroup) {
        return this.request('post', `/campaign/${campaignID}/assetGroups`, assetGroup);
    }

    extendActiveCampaign(campaignID, campaignData) {
        return this.request('post', `/campaign/${campaignID}/extend`, campaignData);
    }

    getCampaign(campaignID) {
        return this.request('get', `/campaign/${campaignID}`, null);
    }

    updateCampaign(campaignID, campaign) {
        return this.request('put', `/campaign/${campaignID}`, campaign);
    }

    useUnusedFunds(campaignID) {
        return this.request('post', `/campaign/${campaignID}/useUnusedFunds`, null);
    }

    getIssues(campaignID) {
        return this.request('get', `/campaign/${campaignID}/issues`, null);
    }

    getRecommendations(campaignID) {
        return this.request('get', `/campaign/${campaignID}/recommendations`, null);
    }

    getCampaignFunds(campaignID) {
        return this.request('get', `/campaign/${campaignID}/funds`, null);
    }

    getMaxSpendRange(startDate, endDate, budgetSpendingStrategyType, currencyShortName) {
        return this.request('get', '/campaign/maxSpendRange', { startDate, endDate, budgetSpendingStrategyType, currencyShortName });
    }

    getMaxSpend(startDate, endDate, maxDailySpend, budgetSpendingStrategyType, currencyShortName) {
        return this.request('get', '/campaign/maxSpend', { startDate, endDate, maxDailySpend, budgetSpendingStrategyType, currencyShortName });
    }

    getCreativeInsights(campaignID) {
        return this.request('get', `/campaign/${campaignID}/creativeInsights`, null);
    }

    getAdditionalDaysRemainingAfterTopUp(campaignID, topUpAmount) {
        return this.request('get', `/campaign/${campaignID}/additionalDaysRemainingAfterTopUp`, { topUpAmount });
    }

    getSpendingSimulation(budget, budgetSpendingStrategyType, endsAt, marketingEventEndsAt, marketingEventStartsAt, startsAt, currencyShortName) {
        return this.request('get',
            '/campaign/spendingSimulation',
            { budget, budgetSpendingStrategyType, endsAt, marketingEventEndsAt, marketingEventStartsAt, startsAt, currencyShortName });
    }

    deleteCampaign(campaignID) {
        return this.request('delete', `/campaign/${campaignID}`, null);
    }

    publishCampaign(campaignID, audienceSettings, maxDailySpend, maxSpend, marketingEventEndsAt, marketingEventStartsAt, name, startsAt, endsAt, launchCampaign) {
        return this.request('put', `/campaign/${campaignID}/publish`, { audienceSettings, maxDailySpend, maxSpend, marketingEventEndsAt, marketingEventStartsAt, name, startsAt, endsAt, launchCampaign });
    }
    getCampaignRating(campaignID) {
        return this.request('get', `/campaign/${campaignID}/rating`);
    }

    getLocationInsights(campaignID, pageNumber = 1, pageSize = 10) {
        return this.request('post', `/campaign/${campaignID}/locationInsights`, { pageNumber, pageSize });
    }
}
